export default __webpack_public_path__ + "static/media/2490.4ccfcef0.png";